import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { Card } from '@salesforce/design-system-react';
import { BrandBand } from '../../common/components';
import InactiveImg from '../../static/img/einstein-inactive.svg';

import './Inactive.scss';

class Inactive extends Component {
  body() {
    return (
      <div className="inactive-container">
        <img src={InactiveImg} alt="Einstein Content Selection: Inactive" />
        <div className="slds-text-longform">
          <h1 className="slds-text-heading_medium">
            <FormattedMessage id="components.ecs.error.types.PROVISION.heading" />
          </h1>
          <p className="slds-text-heading_xsmall">
            <FormattedMessage id="components.ecs.error.types.PROVISION.description" />
          </p>
        </div>
      </div>
    );
  }
  render() {
    let body = this.body();
    if (!this.props.block) {
      body = (
        <BrandBand>
          <Card hasNoHeader={true} className="inactive-card">
            {body}
          </Card>
        </BrandBand>
      );
    }
    return body;
  }
}

Inactive.propTypes = {
  block: PropTypes.bool
};

export default injectIntl(Inactive);
